import { MoreVertical } from "react-feather";
import { H4, Image, P } from "../../../../../../AbstractElements";
import { ELANAHeading } from "../../../../../../Constants/Constants";
import { dynamicImage } from "../../../../../../Utils";

const NewUsersSocial = () => {
  return (
    <div className="new-users-social">
      <div className="d-flex">
        <Image className="rounded-circle image-radius m-r-15" src={dynamicImage(`user/1.jpg`)} alt="user121" />
        <div className="flex-grow-1">
          <H4 className="mb-0">{ELANAHeading}</H4>
          <P>January, 12,2024</P>
        </div>
        <span className="pull-right mt-0">
          <MoreVertical />
        </span>
      </div>
    </div>
  );
};

export default NewUsersSocial;
